import React from "react";

export default function TabLabelWithCount({ label, count }) {
  const n = count != null ? Number(count) : null;
  return (
    <>
      <span className="tab-btn__label" title={label}>
        {label}
      </span>
      <span className="tab-btn__count">{Number.isFinite(n) && n >= 0 ? `(${n})` : ""}</span>
    </>
  );
}

